<template>
  <div class="faq">
    <div class="faq-question-s" v-b-toggle.q26>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q26.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q26')}}</b-col>
      </b-row>
      <b-collapse id="q26">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A26.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a26-1')}}</div>
            <br/>
            <div v-html="$t('a26-2')"></div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q27>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q27.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q27')}}</b-col>
      </b-row>
      <b-collapse id="q27">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A27.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a27-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q28>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q28.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q28')}}</b-col>
      </b-row>
      <b-collapse id="q28">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A28.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a28-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q29>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q29.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q29')}}</b-col>
      </b-row>
      <b-collapse id="q29">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A29.</b></b-col>
          <b-col cols="11">
            <div v-html="$t('a29-1')"></div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q30>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q30.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q30')}}</b-col>
      </b-row>
      <b-collapse id="q30">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A30.</b></b-col>
          <b-col cols="11">
            <div v-html="$t('a30-1')"></div>
            <br/>
            <div>{{$t('a30-2')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q31>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q31.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q31')}}</b-col>
      </b-row>
      <b-collapse id="q31">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A31.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a31-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q32>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q32.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q32')}}</b-col>
      </b-row>
      <b-collapse id="q32">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A32.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a32-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q33>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q33.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q33')}}</b-col>
      </b-row>
      <b-collapse id="q33">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A33.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a33-1')}}</div>
            <br/>
            <div>{{$t('a33-2')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q34>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q34.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q34')}}</b-col>
      </b-row>
      <b-collapse id="q34">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A34.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a34-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q35>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q35.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q35')}}</b-col>
      </b-row>
      <b-collapse id="q35">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A35.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a35-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    redirectLogin() {
      this.$router.push({ name: 'Login' });
    },
    redirectBDweb() {
      switch (this.$i18n.locale) {
        case "en":
          window.open(`https://www.bd.gov.hk/en/index.html`);
          break;
        case "zh_hk":
          window.open(`https://www.bd.gov.hk/tc/index.html`);
          break;
        case "zh_cn":
          window.open(`https://www.bd.gov.hk/sc/index.html`);
          break;
      }
    },
  }
};
</script>

<i18n src="@/public/locales/modules/faq/components/FaqSigning.json" />